import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import linuxLogo  from "../../Assets/tool/linux.png";
import cLogo  from "../../Assets/tool/c.png";
import htmlLogo  from "../../Assets/tool/html.png";
import cssLogo  from "../../Assets/tool/css.png";
import jsLogo  from "../../Assets/tool/js.png";
import pyLogo from "../../Assets/tool/py.png";
import vsLogo  from "../../Assets/tool/vs.png";
import obsLogo   from "../../Assets/tool/obs.png";

import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiJava,
} from "react-icons/di";
import {
  SiRedis,
  SiFirebase,
  SiNextdotjs,
  SiSolidity,
  SiPostgresql,
} from "react-icons/si";
import { TbBrandGolang } from "react-icons/tb";

function Technology() {
  const tools = [
    { src: linuxLogo, alt: "Linux" },
    { src: cLogo, alt: "C/C++" },
    { src: htmlLogo, alt: "HTML" },
    { src: cssLogo, alt: "CSS" },
    { src: jsLogo, alt: "JavaScript" },
    { src: pyLogo, alt: "Python" },
    { src: vsLogo, alt: "Visual Studio" },
    { src: obsLogo, alt: "OBS" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {tools.map((tool, index) => (
        <Col xs={4} md={2} className="tech-icons" key={index}>
          <img
            src={tool.src}
            alt={tool.alt}
            style={{
              width: "80px",
              height: "80px",
              objectFit: "contain",
              marginBottom: "10px",
            }}
          />
          <p style={{ marginTop: "8px", fontSize: "18px", color: "#ccc" }}>
           {tool.alt}
          </p>
        </Col>
      ))}
    </Row>
  );
}

export default Technology;
